import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './app';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import ReactGA from 'react-ga4';
import { Auth0Provider } from '@auth0/auth0-react';
import { env } from './env';

ReactGA.initialize(env.gaMeasurementId);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Auth0Provider
        domain={env.auth0Domain}
        clientId={env.auth0ClientId}
        cacheLocation='localstorage'
        useRefreshTokens={true}
        authorizationParams={{
          audience: env.auth0Audience,
          scope: 'openid profile email offline_access',
          redirect_uri: window.location.origin,
        }}
      >
        <App />
      </Auth0Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
